import { fromJS } from 'immutable';

export function request(state) {
    return state.set('collections', fromJS({
        status: 'IN_PROGRESS',
        items: [],
        aggregations: {}
    }));
}

export function finish(state, { data, aggregations }) {
    let collections = fromJS({
        status: 'FINISHED',
        items: fromJS(data.map(payment => payment.id)),
        aggregations
    });

    let items = state.get('items');
    for (let item of data) {
        items = items.set(item.id, fromJS(item));
    }

    return state
        .set('items', items)
        .set('collections', collections);
}

export function error(state) {
    return state.set('collections', fromJS({
        status: 'ERROR'
    }));
}

export function clear(state) {
    return state.set('collections', {});
}
